import { UserRole } from '../types/api';

export const ROLE_LABELS: Record<UserRole, string> = {
  admin: 'Administrateur',
  organizer: "Gestionnaire d'événements",
  viewer: 'Accueil',
};

export const ROLES = Object.keys(ROLE_LABELS) as UserRole[];

export const apiErrorText = (err: any): string => {
  const detail = err?.response?.data?.detail;
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail)) return detail.map((d) => d.msg).join(' ; ');
  return err?.message || 'Erreur inconnue';
};
